// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconCancelCardPath = 'm15.145 15.002-3.879-5H18v4a1 1 0 0 1-1 1h-1.855ZM3 15.002a1 1 0 0 1-1-1v-4h6.734l3.879 5H3Zm1.855-10 1.552 2H2v-1a1 1 0 0 1 1-1h1.855Zm12.145 0a1 1 0 0 1 1 1v1H8.938l-1.551-2H17Zm-11.164-2L3.802.38l-1.58 1.226 1.083 1.396H3c-1.654 0-3 1.346-3 3v8c0 1.654 1.346 3 3 3h11.164l2.034 2.622 1.58-1.226-1.083-1.396H17c1.654 0 3-1.346 3-3v-8c0-1.654-1.346-3-3-3H5.836Z';
var IconCancelCard = baseIcon('IconCancelCard', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconCancelCardPath
});
export default IconCancelCard;
//# sourceMappingURL=index.js.map